import axios from "axios";

export const YSVLIVE_TOKEN_KEY = "ysvlive_token";

const YSVCHI_BACKEND_URL = (
  process.env.REACT_APP_YSVCHI_BACKEND_URL ||
  "https://ysv-backend-production.up.railway.app"
).replace(/\/$/, "");

export const YSVCHI_SIGN_UP_URL = "https://ysvchi.com/get-started";
export const YSVCHI_PRICING_URL = "https://ysvchi.com/pricing";

export const ysvAuthApi = axios.create({
  baseURL: `${YSVCHI_BACKEND_URL}/api`,
});
ysvAuthApi.interceptors.request.use((config) => {
  const token = localStorage.getItem(YSVLIVE_TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
